import { PaymentEntryEnumType } from 'config/types'
import React from 'react'
import { Dropdown, Form } from 'semantic-ui-react'

const options = [
  { text: 'Depósito', value: PaymentEntryEnumType.DEPOSIT },
  { text: 'Cheque', value: PaymentEntryEnumType.CHEQUE },
  { text: 'Transferencia', value: PaymentEntryEnumType.TRANSFERE },
  { text: 'Traslado de fondos', value: PaymentEntryEnumType.TRANSFER },
  { text: 'Manual', value: PaymentEntryEnumType.MANUAL },
  { text: 'Todos', value: 'ALL' }

]

export default function PaymentEntryTypeSelect({
  error,
  label,
  multiple,
  onChange,
  required,
  value,
  ...props
}) {
  const normalizedValue = multiple
    ? (Array.isArray(value) ? value : value != null ? [value] : [])
    : (Array.isArray(value) ? value[0] : value)

  const handleChange = (_, { value: selectedValues }) => {
    if (!onChange) return
    const values = Array.isArray(selectedValues) ? selectedValues : [selectedValues]
    if (values.includes('ALL')) {
      const current = Array.isArray(value) ? value : value != null ? [value] : []
      if (current.includes('ALL')) {
        onChange(multiple ? [] : undefined)
      } else {
        onChange(multiple ? ['ALL'] : 'ALL')
      }
    } else {
      const filtered = values.filter(v => v !== 'ALL')
      onChange(multiple ? filtered : filtered[0])
    }
  }

  return (
    <Form.Field error={error} required={required}>
      {label && <label>{label}</label>}

      <Dropdown {...props} multiple={multiple} options={options} onChange={handleChange} value={normalizedValue} />
    </Form.Field>
  )
}

PaymentEntryTypeSelect.defaultProps = {
  label: 'Tipo de Transacción',
  placeholder: 'Tipo',
  fluid: true,
  search: false,
  selection: true,
  selectOnBlur: false,
  selectOnNavigation: false,
  noResultsMessage: null,
}
